import { HeaderLink } from 'src/components/ZillowNavbar/page-frame-types/HeaderLink';
import { HeaderLinkDescription } from 'src/components/ZillowNavbar/page-frame-types/HeaderLinkDescription';

export const isHeaderLink = (linkOrDescription: HeaderLink | HeaderLinkDescription): linkOrDescription is HeaderLink =>
    !!(linkOrDescription as HeaderLink).href;
